import { Tag } from 'antd';
import { Link } from 'react-router';
import type {
  AntdMenuItem,
  CreateLevel2ItemsArgs,
  CreateLevelItemsArgs,
  CreateMenuItemsArgs,
  Level1LabelProps,
} from './lib/types';

const Level1Label = ({ item }: Level1LabelProps) => {
  if (item.tag) {
    return (
      <a href="#123">
        <span>{item.title}</span>
        <Tag style={{ marginRight: -14 }}>{item.tag}</Tag>
      </a>
    );
  }

  return <Link to={item.navLink || ''}>{item.title}</Link>;
};

const createLevel3Items = ({ items, onClose }: CreateLevelItemsArgs): AntdMenuItem[] => {
  return items.map((childItem) => ({
    key: childItem.id || '',
    onClick: onClose,
    label: <Link to={childItem.navLink || ''}>{childItem.title}</Link>,
  }));
};

const createLevel2Items = ({
  items,
  currentLocation,
  defaultSelectedKey,
  onClose,
  getPathnameWithoutQuery,
  userPermissions,
}: CreateLevel2ItemsArgs): AntdMenuItem[] => {
  return items
    .map((itemChildren) => {
      const isVisible = userPermissions?.includes(itemChildren.permission || '');

      if (!isVisible) {
        return null;
      }

      if (!itemChildren.children) {
        return {
          key: itemChildren.id || '',
          onClick: onClose,
          label: <Link to={itemChildren.navLink || ''}>{itemChildren.title}</Link>,
        };
      }

      return {
        key: itemChildren.id || '',
        label: itemChildren.title,
        children: createLevel3Items({
          items: itemChildren.children,
          currentLocation,
          defaultSelectedKey,
          onClose,
          getPathnameWithoutQuery,
        }),
      };
    })
    .filter(Boolean) as AntdMenuItem[];
};

export const createMenuItems = ({
  menuVisibleItems,
  currentLocation,
  defaultSelectedKey,
  onClose,
  getPathnameWithoutQuery,
  userPermissions,
}: CreateMenuItemsArgs): AntdMenuItem[] => {
  return menuVisibleItems.map((item, index) => {
    if (item.header) {
      return {
        key: `group-${index}`,
        type: 'group',
        label: item.header,
      };
    }

    if (item.children) {
      return {
        key: item.id || '',
        icon: item.icon,
        label: item.title,
        children: createLevel2Items({
          items: item.children,
          currentLocation,
          defaultSelectedKey,
          onClose,
          getPathnameWithoutQuery,
          userPermissions,
        }),
      };
    }

    return {
      key: item.id || '',
      icon: item.icon,
      onClick: onClose,
      style: item.tag ? { pointerEvents: 'none' } : undefined,
      label: <Level1Label item={item} />,
    };
  });
};
